import React, { cloneElement } from 'react';
import { StyledTagGroup } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import {} from '../tag/index.js';
export const TagGroup = ({ children, size, className, 'data-testid': dataTestId, margin }) => {
    const modifiedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                size: child.props.size ?? size
            });
        }
        return null;
    });
    return (React.createElement(StyledTagGroup, { size: size, className: className, "data-testid": dataTestId, margin: margin }, modifiedChildren));
};
//# sourceMappingURL=index.js.map